<template>
  <el-dialog
    :title="$t('text.add_manufacturer')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    append-to-body
    :modal-append-to-body="false"
    @close="closeDialog()"
    width="400px"
  >
    <div>
      <el-form
        label-width="110px"
        :model="form"
        ref="form"
        label-position="top"
      >
        <el-form-item
          :label="$t('text.manufacturer_subscription_code')"
          prop="ManufacturerCode"
          :rules="[
            {
              required: true,
              message: this.$t('text.please_enter_subscription_code'),
              trigger: 'blur'
            }
          ]"
        >
          <el-input
            v-model="form.ManufacturerCode"
            autocomplete="off"
            :placeholder="$t('text.subscription_code')"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="getManufacturerByCode()"
        :loading="loading"
        >{{ $t('text.add').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        ManufacturerCode: ''
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        ManufacturerCode: ''
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    getManufacturerByCode() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.GetManufacturerByCode(this.form.ManufacturerCode)
            .then(response => {
              this.loading = false
              if (response.data.success) {
                this.addOrganisationManufacturer({
                  ManufacturerId: response.data.data.id,
                  Code: this.form.ManufacturerCode,
                  OrganisationId: this.$store.getters[
                    `user/selecteOrganisationId`
                  ]
                })
              } else {
                swal({
                  icon: 'warning',
                  timer: 2000,
                  title: this.$t('text.failed'),
                  text: response.data.msg + '.'
                })
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    addOrganisationManufacturer(params) {
      this.loading = true
      ApiService.AddOrganisationManufacturer(params)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.$emit('updateManufactures')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.added_successfully')
            })
            this.closeDialog()
          } else {
            swal({
              icon: 'warning',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
